































import {Vue, Component, Prop} from "vue-property-decorator";
import ConfirmedAction from "@/components/ConfirmedAction.vue";
import SectionHeader from "@/components/SectionHeader.vue";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import Loading from "@/components/Loading.vue";
import Success from "@/components/Success.vue";
import VueError from "@/components/VueError.vue"
import { LoraParser } from '@/types/core';

  @Component({
    components: {
      SectionHeader,
      ConfirmedAction,
      VueError,
      Success,
      Loading
    }
  })
  export default class LoraParserDelete extends Vue {
    
    httpGetParserBusy:boolean = false;
    loraParser:LoraParser = {} as LoraParser;
    success = '';
    error = '';

    private coreClient:CoreClient = curCoreClient;

    async mounted() {

      this.getParser();
    }

    async getParser() {

      this.httpGetParserBusy = true;

      const reply = await this.coreClient.getLoraParser({loraParserId: this.$route.params.loraParserId});

      this.httpGetParserBusy = false;

      if(reply.httpCode === 403)
        return this.$router.push({name:'login'});

      if(reply.errorMsg)
        return this.error = `Unable to load lora parser information: ${reply.errorMsg}`;
      
      this.loraParser = reply.loraParser!;
    }

    async deleteDecoder() {

      const reply = await this.coreClient.deleteLoraParser({loraParserId: this.loraParser.loraParserId});

      if(reply.httpCode === 403)
        return this.$router.push({name:'login'});

      if(reply.errorMsg)
        return this.error = `Unable to delete lora parser: ${reply.errorMsg}`;

      this.setSuccess(`Lora parser '${this.loraParser.name}' has been deleted`);
    }

    setSuccess(str:string) {
      this.success = str;
      setTimeout(() => this.$router.push({name:'lora-parser-list'}), 1000);
    }

    get canDelete() {
      return this.loraParser && this.loraParser.loraParserId;
    }

    cancel() {
      return this.$router.push('/lora-parsers');
    }

  }
